export const PREFILLED_CARD_DATA_CACHE_KEY = 'GET_BLINQ_PREFILLED_INFO_FROM_CARD_PAGE';

export const REFERRAL_DATA_CACHE_KEY = 'GET_BLINQ_REFERRAL_TRACKING_DATA';

export const OPAQUE_TOKEN_CACHE_KEY = 'GET_BLINQ_OPAQUE_TOKEN';

export const ACCEPTABLE_PREFILLED_CARD_DATA_QUERY_STRINGS = [
  '_dl',
  'firstName',
  'lastName',
  'email',
  'phoneNumber',
  'jobTitle',
  'orgName',
] as const;

export type ReferralDataQueryStringKey = (typeof ACCEPTABLE_PREFILLED_CARD_DATA_QUERY_STRINGS)[number];
